<template>
  <v-app>
  <v-main>
  <div id="main">
    <!-- Poner el navbar de proyectos izquierdo -->
    <ProjectsListComponent />

    <!-- Contenido dinámico -->
    <div style="width: 100%; height: 100vh;">
      <slot></slot>
    </div>

    <!-- Buscador de proyectos -->
    <v-dialog v-model="showProjectSearchDialog" width="60%" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="projectSearchQuery"
            label="Buscar proyecto..."
            prepend-inner-icon="mdi-magnify"
            @keyup="handleProjectSearchInput"
            clearable
            ref="projectSearchInput"
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-progress-circular v-if="projectLoading" indeterminate color="primary"></v-progress-circular>
          <v-row v-else>
            <v-col v-for="(project, index) in projectSearchResults" :key="index" cols="12" sm="6" md="4">
              <v-card>
                <v-img :src="project.iconUrl" height="200px"></v-img>
                <v-card-title>{{ project.name }}</v-card-title>
                <v-card-actions>
                  <v-btn color="primary" @click="viewProject(project)">Abrir</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeProjectSearchDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor" class="snackbar">
      <v-icon class="snackbar-icon" dark>{{ snackbarIcon }}</v-icon>
      <span class="snackbar-text">{{ snackbarText }}</span>
    </v-snackbar>
  </div>
  </v-main>
  </v-app>
</template>

<script>
import ProjectsListComponent from '@/components/ProjectsListComponent.vue';
import api from '@/api.js';

export default {
  name: 'BaseView',
  components: {
    ProjectsListComponent
  },
  computed: {
    email(){
      return localStorage.getItem('email');
    },
    snackbar: {
      get() {
      return this.$store.state.snackbar;
      },
      set(value) {
        this.$store.commit('restoreSnackbar', value);
      }
    },
    snackbarText(){
      return this.$store.state.snackbarText;
    },
    snackbarColor(){
      return this.$store.state.snackbarColor;
    },
    snackbarIcon(){
      return this.$store.state.snackbarIcon;
    }
  },
  data() {
    return {
      showProjectSearchDialog: false,
      projectSearchQuery: '',
      projectSearchResults: [],
      projectLoading: false,
      projectSearchTimeout: null,
    }
  },
  methods: {
    async getUserAccount(){
      try{
        const response = await api.get('/api/user/userLogin');
        this.$store.commit('set', {att: 'user', value: response.data});
      } catch (error) {
        console.error('Error al obtener la cuenta del usuario:', error);
      }
    },
    openProjectSearchDialog() {
      this.showProjectSearchDialog = true;
      // Hacer focus en el input de búsqueda
      this.$nextTick(() => {
        this.$refs.projectSearchInput.focus();
      });
    },
    closeProjectSearchDialog() {
      this.showProjectSearchDialog = false;
    },
    handleProjectSearchInput() {
      clearTimeout(this.projectSearchTimeout);
      this.projectSearchTimeout = setTimeout(() => {
        this.performProjectSearch();
      }, 1000);
    },
    async performProjectSearch() {
      this.projectLoading = true;
      const queryArray = this.projectSearchQuery.split(/[\s,.]+/);
      console.log('query array:', queryArray);
      try {
        const response = await api.post(`/api/project/findByName`, {
          name: queryArray
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });

        // Filtrar los que el usuario realmente pertenece
        response.data = response.data.filter(project => project.userMembers.includes(this.email));
        this.projectSearchResults = response.data;
        console.log('resultados', this.projectSearchResults);
      } catch (error) {
        console.error('Error al realizar la búsqueda de proyectos:', error);
      } finally {
        this.projectLoading = false;
      }
    },
    viewProject(project) {
      window.location.href = `/p/${project._id}/home`;
    },
    handleKeydown(event) {
      if (event.ctrlKey && event.key === 'p') {
        event.preventDefault();
        this.openProjectSearchDialog();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeydown);
    this.getUserAccount();
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
}
</script>

<style scoped>
#main{
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow: hidden;  /* CLAVE PARA QUE NO SE SALGA EL CONTENIDO */
}
</style>